import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  Renderer2,
} from "@angular/core";

@Directive({
  selector: "[abAutoSizeInput]",
})
export class AutoSizeInputDirective implements AfterViewInit, OnDestroy {
  public elem: HTMLInputElement;
  public mirror: HTMLSpanElement;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener("keyup") public onKeyup() {
    this.resize();
  }

  public ngAfterViewInit() {
    this.elem = this.elementRef.nativeElement;

    this.mirror = this.renderer.createElement("span");
    this.renderer.setStyle(this.mirror, "position", "fixed");
    this.renderer.setStyle(this.mirror, "top", "-9999px");
    this.renderer.setStyle(this.mirror, "visibility", "hidden");
    this.renderer.setStyle(this.mirror, "whiteSpace", "pre");
    this.renderer.setStyle(
      this.mirror,
      "fontSize",
      getComputedStyle(this.elem).fontSize,
    );
    this.renderer.appendChild(document.body, this.mirror);

    this.resize();
  }

  public ngOnDestroy() {
    this.renderer.removeChild(document.body, this.mirror);
  }

  private resize() {
    const elemText = this.elem.value ? this.elem.value : this.elem.placeholder;
    this.renderer.setProperty(this.mirror, "textContent", elemText);
    this.renderer.setStyle(
      this.elem,
      "width",
      `${this.mirror.offsetWidth + 8}px`,
    );
  }
}
